/**
 * Testi statici dell’attestazione ECM (cert2), allineati al modello OPL.
 * Se in futuro arrivano dal backend, sostituire con props sul componente.
 */
export const FCS_TRAINING_OBJECTIVE_PARAGRAPH =
  '17 - Argomenti di carattere generale: sanità digitale, informatica di livello avanzato e lingua inglese scientifica. Normativa in materia sanitaria: i principi etici e civili del S.S.N. e normativa su materie oggetto delle singole professioni sanitarie, con acquisizione di nozioni di sistema.';

export const FCS_ECM_CREDITS_LEGAL_REF =
  '(secondo i parametri stabiliti dai “Criteri per l’assegnazione dei crediti alle attività ECM” allegati all’Accordo Stato-Regioni del 02/02/2017)';
